import { AutoAwesome } from "@mui/icons-material";
import { IconButton, type IconButtonProps, type SxProps, type Theme } from "@mui/material";
import type React from "react";
import { SURFACE } from "../../theme/tokens";
import { trackEvent } from "../../utils/analytics";

interface CopilotButtonProps extends Omit<IconButtonProps, "sx"> {
	open?: boolean;
	sx?: SxProps<Theme>;
}

export const CopilotButton: React.FC<CopilotButtonProps> = ({ open, onClick, sx, ...props }) => {
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		trackEvent("copilot_button_clicked", { is_open: open });
		onClick?.(event);
	};

	if (open) return null;

	return (
		<IconButton
			color="inherit"
			aria-label="copilot button"
			onClick={handleClick}
			edge="start"
			sx={[
				(theme) => ({
					bgcolor: theme.palette.primary.main,
					color: SURFACE,
					marginLeft: "10px",
					"&:hover": { bgcolor: theme.palette.primary.dark },
				}),
				...(Array.isArray(sx) ? sx : [sx ?? false]),
			]}
			{...props}
		>
			<AutoAwesome />
		</IconButton>
	);
};

export default CopilotButton;
